import React from "react";

const LookupSelect = ({ title, active, selected, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="py-1.5 px-3 flex items-center cursor-pointer bg-zinc-100 rounded mr-2"
    >
      <div className="top-2 left-2 w-3 h-3 mr-0.5 border border-solid border-gray-800  flex items-center justify-center">
        {active && <span className="w-2 h-2 bg-secondary"></span>}
      </div>
      <div className="text-xs whitespace-nowrap">{title}</div>
    </div>
  );
};

export default LookupSelect;
